import React from "react";
import {
  BoldFont,
  FlexRowBetween,
  GenericDiv,
  MediumFont,
  MyHr,
  PopupForm,
} from "../Style";
import ClientRoutes from "../../../navigation/Routes";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { editDetails } from "../../../store/reducers/authReducer";
import { toast } from "react-toastify";

const CanWeStart = ({ init }) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const handleSetIsReady = () => {
    dispatch(editDetails({ isReady: true })).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init(false);
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "space-around",
        }}
      >
        <div style={{ width: "100%", marginTop: "30px" }}>
          <BoldFont
            style={{
              textAlign: "center",
              fontSize: "1.2rem",
              marginBottom: "10px",
            }}
          >
            שימו לב
          </BoldFont>
          <MyHr />
        </div>
        <div style={{ width: "100%", marginTop: "30px" }}>
          <MediumFont
            style={{
              textAlign: "right",
              marginBottom: "10px",
              padding: "0 20px",
            }}
          >
            {/* <div> */}
            <div>עוד לא אישרתם לנו להתחיל אישורי הגעה, </div>
            <div>לחצו על ״עשינו הכל אפשר להתחיל״ במידה ו:</div>
            <div>- שלחתם הזמנות לכל האורחים</div>
            <div>- כל האורחים במערכת</div>
            <div>- שלחתם הזמנה לשירות לקוחות על מנת שיכניס למערכת</div>
            <div>- ביצעתם את הסרטונים ששירות הלקוחות שלח לכם</div>
            <div>
              <br />
            </div>
            <div>
              במידה ועוד לא אנא היצמדו ללו"ז כדי שנעבור תהליך מסודר ונעים
            </div>
            {/* </div> */}
          </MediumFont>
          <MyHr />
        </div>
        <div style={{ width: "100%" }}>
          <FlexRowBetween style={{ width: "90%", margin: "20px auto" }}>
            <GenericDiv
              style={{
                background: "rgba(41,59,90,0.95)",
                padding: "9px 25px",
                width: "min-content",
                height: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => handleSetIsReady()}
            >
              עשינו הכל אפשר להתחיל
            </GenericDiv>
            <GenericDiv
              style={{
                background: "rgb(223, 223, 223)",
                color: "#3A3C3F",
                padding: "9px 25px",
                width: "min-content",
                height: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => init(false)}
            >
              עוד לא
            </GenericDiv>
            <GenericDiv
              style={{
                background: "#7b96c4",
                color: "#fff",
                padding: "9px 25px",
                fontWeight: "700",
                letterSpacing: "1px",
                width: "min-content",
                height: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => history.push(ClientRoutes.User.todos)}
            >
              לו״ז
            </GenericDiv>
          </FlexRowBetween>
        </div>
      </div>
    </PopupForm>
  );
};
export default CanWeStart;
